<p-galleria *ngIf="!showOnlyPhoto"
  [value]="photos"
  [(visible)]="displayGalleria"
  [responsiveOptions]="responsiveOptions"
  [(activeIndex)]="activeIndex"
  [containerStyle]="{'max-width': '850px'}"
  [numVisible]="7"
  [circular]="true"
  [fullScreen]="true"
  [showItemNavigators]="true"
  [showThumbnails]="false"
  [baseZIndex]="100000"
  (close)="closeGalleria()">
  <ng-template
    pTemplate="item"
    let-item>
    <img
      [src]="util.getFilePath() + item"
      style="width: 100%; display: block;"  alt=""
      loading="lazy"
      (error)="onImageError($event)">
  </ng-template>
</p-galleria>
<div
  class="p-formgrid p-grid media"
  [ngClass]="{'remove-border-btm': removeBorder}">
  <div class="p-flex-column p-d-flex">

    <ng-container [ngSwitch]="isLink">

      <ng-container *ngSwitchCase="true">
        <app-real-property-details-link [id]="applicationId">
          <ng-container *ngTemplateOutlet="mediaContent"></ng-container>
        </app-real-property-details-link>
      </ng-container>

      <ng-container *ngSwitchCase="false">
        <ng-container *ngTemplateOutlet="mediaContent"></ng-container>
      </ng-container>

    </ng-container>

    <app-carousel *ngIf="photos?.length > 1 && !showOnlyPhoto"
      [videos]="videos"
      [imageList]="photos"
      [housingPlans]="housingPlans"
      [totalPhotos]="photos?.length > galleryVisibleImageCount + 1 ? photos?.length - galleryVisibleImageCount + 1 : 0"
      (openGalleria)="onOpenGalleria($event)"
      [carouselVisibleImageCount]="galleryVisibleImageCount"
      [itemWidth]="galleryItemWidth"
      [itemHeight]="galleryItemHeight">
    </app-carousel>

    <ng-container *ngIf="showToolbar">
      <app-real-property-toolbar
        class="favorite-toolbar"
        [applicationId]="applicationId"
        [mode]="toolbarMode"
        [inFavourites]="inFavourites"
        [realPropertyId]="realPropertyId"
        [likesCount]="likesCount"
        [commentsCount]="commentsCount"
        [form]="toolBarForm"
      >
      </app-real-property-toolbar>
    </ng-container>
  </div>
</div>
<div class="line desktop-view" [ngStyle]="{ width: containerStyles.width }"></div>

<ng-template #mediaContent>
  <div
    class="p-d-flex p-ai-end content-container"
    (click)="onOpenPhoto(photos[0])"
    [ngStyle]="containerStyles">
    <div
      class="main-frame">
      <app-media-content
        [imageList]="photos"
        [housingPlans]="housingPlans"
        [playVideo]="playVideo"
        [prefix]="prefix"
        [canOpenPhoto]="canOpenPhoto"
        [videoSource]="videos ? videos[0] : null"
        [videoElementId]="applicationId"
        [mediaContainerWidth]="containerWidth"
        [mediaContainerHeight]="containerHeight"
        [reserved]="reserved"
        [showOnlyPhoto]="showOnlyPhoto">
      </app-media-content>
    </div>

  </div>
</ng-template>
